export enum LoginStatus {
  Success = 1,
  Error = 2,
}

export enum Roles {
  Administrator = "Administrator",
  LocalAdmin = "Site Admin",
  Basic = "Basic",
  Location = "Location Group",
  Indexers = "Indexers",
  Checkers = "Checkers",
  FARS = "FARS",
  Management = "Management",
}

export function hasPermission(user: UserInfo, permissionName: string) {
  //console.debug("hasPermission in Login/common defaults", user, permissionName);
  //console.trace();
  if (
    user &&
    user.userPermissions &&
    user.userPermissions.find((y) => y.permission.name == permissionName)
  ) {
    return true;
  }
  if (
    user &&
    user.userRoles &&
    user.userRoles.find((x) =>
      x.role.rolePermissions.find((y) => y.permission.name == permissionName)
    )
  ) {
    return true;
  }
  return false;
}

export function isAdmin(user: UserInfo): boolean {
  if (this.userRoles.find((x) => x.role.name == "Administrator")) {
    return true;
  }
  return false;
}

export function userIsAdmin(user: UserInfo): boolean {
  return !!user.userRoles.find((x) => x.role.name == "Administrator");
}

export class UserInfo {
  constructor(
    public id?: number,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public phone?: string,
    public loginType?: number,
    public active?: boolean,
    public username?: string,
    public password?: string,
    public userRoles?: UserRole[],
    public userPermissions?: any[],
    public token?: string,
    public lastUpdatedBy?: number,
    public lastUpdated?: string,
    public createdBy?: number,
    public created?: string
  ) {}

  // hasPermission(permissionName: string): boolean {
  //   if (this.userPermissions.find(y => y.permission.name == permissionName)) {
  //     return true;
  //   }
  //   if (
  //     this.userRoles.find(x =>
  //       x.role.rolePermissions.find(y => y.permission.name == permissionName)
  //     )
  //   ) {
  //     return true;
  //   }
  //   return false;
  // }

  // isAdmin(): boolean {
  //   if (this.userRoles.find(x => x.role.name == 'Administrator')) {
  //     return true;
  //   }
  //   return false;
  // }
}

export interface ILoginRequest {
  Username: string;
  Password: string;
}

export interface ILoginResponse {
  Error: string;
  Success: LoginStatus;
  User: UserInfo;
}

export class UserRole {
  constructor(
    public roleId: number,
    public userId: number,
    public id?: number,
    public role?: RoleInfo,
    public user?: UserInfo
  ) {}
}

export class UserPermission {
  constructor(
    public userId: number,
    public permissionId: number,
    public user?: UserInfo,
    public permission?: Permission
  ) {}
}

export class RolePermission {
  constructor(
    public roleId: number,
    public permissionId: number,
    public role?: RoleInfo,
    public permission?: Permission,
    public id?: number
  ) {}
}

export class Permission {
  constructor(
    public id: number,
    public name: string,
    public userRold?: UserRole,
    public userPermission?: UserPermission
  ) {}
}

export class RoleInfo {
  constructor(
    public id?: number,
    public name?: string,
    public description?: string,
    public active?: boolean,
    public created?: string,
    public createdBy?: number,
    public updatedById?: number,
    public lastUpdated?: string,
    public rolePermissions?: RolePermission[]
  ) {}
}

export interface IAdminInfoResponse {
  users: UserInfo[];
  roles: RoleInfo[];
  permissions: Permission[];
}
